import { useState, useEffect } from 'react';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import { themeStore } from '../../stores/theme';
import { useStore } from '@tanstack/react-store';

const AddressAutocomplete = ({ value = "", onSelect, placeholder }) => {
    const { isDarkMode } = useStore(themeStore);
    const {
        ready,
        value: autocompleteValue,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({ debounce: 300 });

    const [inputValue, setInputValue] = useState('');

    // Pre-fill from initial value (if editing)
    useEffect(() => {
        if (value?.name) {
            setInputValue(value.name);
            setValue(value.name, false);
        } else if (typeof value === 'string') {
            setInputValue(value);
            setValue(value, false);
        }
    }, [value, setValue]);

    const handleInput = (val) => {
        if (val === '') {
            onSelect?.({
                coordinates: [0, 0],
                type: 'point',
                name: ''
            });
        }
        setInputValue(val);
        setValue(val);
    };

    const handleSelect = async (address) => {
        setValue(address, false);
        setInputValue(address);
        clearSuggestions();
        try {
            const results = await getGeocode({ address });
            const { lat, lng } = await getLatLng(results[0]);
            onSelect?.({
                coordinates: [lng, lat],
                type: 'point',
                name: address
            });
        } catch (error) {
            console.error('Error fetching geocode:', error);
        }
    };

    return (
        <div className="relative w-full">
            <input
                value={inputValue}
                onChange={(e) => handleInput(e.target.value)}
                disabled={!ready}
                placeholder={placeholder}
                className={`${isDarkMode ? 'bg-[#374151] text-white' : 'bg-[#fff] text-gray-800'} w-full p-3 rounded shadow-sm`}
            />
            {status === 'OK' && (
                <ul
                    className={`absolute z-10 w-full ${isDarkMode ? 'bg-[#374151]' : 'bg-[#fff]'} rounded shadow-md max-h-60 overflow-y-auto mt-1`}>
                    {data.map(({ place_id, description }) => (
                        <li
                            key={place_id}
                            onClick={() => handleSelect(description)}
                            className={`${isDarkMode ? 'bg-[#374151] text-white' : 'bg-[#fff] text-gray-800'} px-4 py-2 cursor-pointer`}>
                            {description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
export default AddressAutocomplete;